module.exports = __webpack_public_path__ + "img/kangaroo.e14b0d13.png";